import React, {
  useEffect,
  useContext,
  useState,
  useLayoutEffect,
  useMemo,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { Row, Col, Button, Spin, Carousel } from 'antd';
import { FaSearch } from 'react-icons/fa';
import { GiCancel } from 'react-icons/gi';
import InfiniteScroll from 'react-infinite-scroll-component';
import i18n from 'i18next';
import { getMeals, getMoreMeals } from '../../store/meals/actions';
import { getAppGlobalState } from '../../store/app-globals/selectors';
import { getUserState } from '../../store/user/selector';

import { Navbar } from '../layout/Header';
import { MealSearchLoading } from './components/MealSearchLoading';
import { MealCarouselSelection } from './components/MealCarousel';
import { DesktopMealCarouselSelection } from './components/DesktopMealCarousel';
import { History } from 'history';
import {
  setFilterData,
  setCurrentLocation,
  getUserRating,
} from '../../store/user/actions';
import { usePosition } from 'use-position';
import { getAds } from '../../store/admin/actions';
import { getAdminState } from '../../store/admin/selector';
import { getMealState } from '../../store/meals/selector';

const COOK = 'i offer';
const GUEST = 'i seek';

export interface AccountTypeContextProps {
  forWho?: string;
  handleAccountTypeChange?: () => void;
}

export const AccountTypeContext = React.createContext<AccountTypeContextProps>({
  forWho: 'i offer',
});

export const BottomItems: React.FC = () => {
  const { forWho, handleAccountTypeChange } = useContext(AccountTypeContext);
  const { user, dataFilter } = useSelector(getUserState);
  const [isloading, setLoading] = useState(false);
  const { userid } = user;
  const toChange = forWho === GUEST ? COOK : GUEST;
  const dispatch = useDispatch();
  const handleRemoveFilter = () => {
    setLoading(true);
    const filterData = {
      isFilter: false,
      distance: 0,
      consumption: '',
      price: 0,
      category: [],
      restrictions: [],
      selectedDate: {
        from: '',
        to: '',
      },
      keyword: '',
      constantOffer: false,
    };
    setTimeout(() => {
      dispatch(setFilterData(filterData));
      setLoading(false);
    }, 2000);
  };
  return (
    <Col xs={24} sm={24} md={18} lg={18} xl={18}>
      <Row>
        <Col flex="auto" style={{ height: 30 }}>
          {dataFilter.isFilter ? (
            <Row justify="start">
              {isloading ? (
                <Row>
                  <Col span={24} offset={2}>
                    <Spin />
                    <span style={{ marginLeft: 10 }}>Removing Filters...</span>
                  </Col>
                </Row>
              ) : (
                <Row>
                  <Button className="search-icon" onClick={handleRemoveFilter}>
                    <GiCancel size={20} color="#B4B4B4" />
                  </Button>

                  <span>
                    {i18n.t('Offer')} are filtered click button x to remove!
                  </span>
                </Row>
              )}
            </Row>
          ) : (
            <Link to="/dashboard/filter">
              <Button type="link" className="search-icon">
                <FaSearch size={20} color="#B4B4B4" />
              </Button>
            </Link>
          )}
          {!userid && (
            <Col flex="auto">
              <Button type="link" onClick={handleAccountTypeChange}>
                <span>{`Became ${toChange}`}</span>
              </Button>
            </Col>
          )}
        </Col>
      </Row>
    </Col>
  );
};

export const getAnotherMeals = (dispatch: any) => {
  dispatch(getMoreMeals());
};

export const Dashboard: React.FC = () => {
  const { isLoading, message } = useSelector(getAppGlobalState);
  const { user } = useSelector(getUserState);
  const { advertisement } = useSelector(getAdminState);
  const { meals, lastMealField } = useSelector(getMealState);
  const { userid, accountType } = user;
  const [forWho, setForWho] = useState('i seek');
  const [width, setWidth] = useState<number>(0);
  const isCook = accountType === COOK;
  const dispatch = useDispatch();
  const history: History = useHistory();

  const settings = useMemo(
    () => ({ enableHighAccuracy: true, timeout: 0, maximumAge: Infinity }),
    []
  );

  const watch = true;
  const { latitude, longitude } = usePosition(watch, settings);

  const handleAccountTypeChange = () => {
    const tempForWho = forWho === COOK ? GUEST : COOK;
    setForWho(tempForWho);
  };

  const validate = () => {
    if (isCook && userid) {
      history.push('/profile');
      return;
    }

    dispatch(getMeals());
    dispatch(getAds());
    dispatch(getUserRating());
  };

  useEffect(validate, [dispatch, isCook, history]);
  useEffect(() => {
    dispatch(setCurrentLocation({ lat: latitude, lng: longitude }));
  }, [latitude, longitude, dispatch]);
  useLayoutEffect(() => {
    const updateSize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  const isDesktop = width >= 900;
  return (
    <AccountTypeContext.Provider value={{ forWho, handleAccountTypeChange }}>
      <div className="dashboard">
        <Row justify="center">
          <Navbar />
        </Row>
        <div
          style={{
            padding: isDesktop ? '30px' : '10px',
          }}
          className="banner-container"
        >
          <Carousel autoplay effect="fade">
            {advertisement &&
              advertisement
                .filter(item => item.position === 'Top')
                .map((item, i) => (
                  <div
                    key={i}
                    onClick={() => window.open(item.siteUrl, '_blank')}
                  >
                    <img
                      src={item.image}
                      className="banner-image"
                      style={{ cursor: 'pointer' }}
                    />
                  </div>
                ))}
          </Carousel>
        </div>
        <Row justify="center" className="meal-caroursel-row">
          {isLoading && message === 'Fetching Meals' ? (
            <MealSearchLoading />
          ) : isDesktop ? (
            <DesktopMealCarouselSelection />
          ) : (
            <MealCarouselSelection />
          )}
        </Row>
        {isLoading && message === 'Fetching more meals' ? (
          <div>
            <h1>Loading more offers..</h1>
          </div>
        ) : null}

        <Row justify="center" className="footer-items">
          {isDesktop ? null : <BottomItems />}
        </Row>
        {isDesktop ? (
          <div
            style={{
              padding: isDesktop ? '30px' : '10px',
            }}
            className="banner-container"
          >
            <Carousel autoplay effect="fade">
              {advertisement &&
                advertisement
                  .filter(item => item.position === 'Bottom')
                  .map((item, i) => (
                    <div key={i}>
                      <img src={item.image} className="banner-image" />
                    </div>
                  ))}
            </Carousel>
          </div>
        ) : null}
      </div>
    </AccountTypeContext.Provider>
  );
};
